






import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { DefaultNonHealthMessage } from '../../js/consts/chat';

@Component({
    name: 'nonHealthService',
    components: {},
})

export default class PetDetails extends Vue {
    @Prop({ type: Boolean }) visible!: boolean;
    @Prop({ type: String }) message!: string;

    constructor() {
        super();
    }

    get getMessage(): string {
        return this.message || DefaultNonHealthMessage;
    }
}

